import Vue from 'vue';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import axios from 'axios';
import '../../../../filters';

export default {
  name: 'OmMaintenanceRequest',
  mixins: [validationMixin],
  components: {
    ElementComp: require('../../element.vue').default,
  },
  props: ['dataObj'],
  data: function () {
    return {
      appId: -1,
      costCenters: [],
      costCenter: { text: '', value: '' },
      groupCodes: [],
      groupCode: { text: '', value: '' },
      maintenanceToElementType: [],
      maintenances: [],
      maintenance: { text: '', value: '' },
      serviceTypes: [],
      serviceType: { text: '', value: '' },
      streetMaintenances: [],
      elementData: {
        elemenTypeDisabled: true,
        elementTypeId: -1,
        elementId: -1,
        maintenanceActivityId: this.dataObj.appData.maintenanceId
      },
      message: '',
    }
  },
  validations: {
    maintenanceValue: {
      required
    },
    serviceTypeValue: {
      required
    },
    elementValue: {
      required
    },
    groupCodeValue: {
      required
    },
  },
  computed: {
    elementId: function () {
      return this.elementData.elementId;
    },
    elementTypeId: function () {
      return this.elementData.elementTypeId;
    },
  },
  watch: {
    elementId: function (value) {
      this.dataObj.appData.elementId = value;
    },
    elementTypeId: function (value) {
      this.dataObj.appData.elementTypeId = value;
    },
    maintenance: function (value) {
      if (!value)
        return;
      this.dataObj.appData.maintenanceId = value.value;
      this.elementData.elementTypeId = this.dataObj.appData.maintenanceToElementType[this.dataObj.appData.maintenanceId];

      this.$root.$emit('element_data_updated');
    },
    serviceType: function (value) {
      if (!value)
        return;
      this.dataObj.appData.serviceTypeId = value.value;
      //if (this.dataObj.appData.serviceTypeToStation && this.dataObj.appData.isStationByServiceType === true) {
      //  var stationId = this.dataObj.appData.serviceTypeToStation[value.value];
      //  if (stationId) {
      //    const newStation = this.stations.filter(p => p.value === stationId.toString()) && this.stations.filter(p => p.value === stationId.toString()).length > 0 ? this.stations.filter(p => p.value === stationId.toString())[0] : null;
      //    this.station = newStation ? newStation : { text: '', value: '' };
      //  }
      //  else
      //    this.station = { text: '', value: '' };
      //}
    },
    costCenter: function (value) {
      if (!value)
        return;
      this.dataObj.appData.costCenterId = value.value;
    },
    groupCode: function (value) {
      if (!value)
        return;
      this.dataObj.appData.groupCodeId = value.value;
    },
  },
  created() {
    this.$material.locale.dateFormat = 'dd/MM/yyyy';
    this.$root.$on('om_maintenance_request_updated', this.init);
    this.init();
  },
  methods: {
    init() {
      Vue.nextTick(() => {
        this.appId = this.dataObj.appId;
        this.costCenters = this.dataObj.appData.costCenters;
        if (this.costCenters && this.costCenters.length > 0)
          this.costCenter = this.costCenters.filter(p => p.value == this.dataObj.appData.costCenterId)[0];
        this.groupCodes = this.dataObj.appData.groupCodes;
        if (this.groupCodes && this.groupCodes.length > 0)
          this.groupCode = this.groupCodes.filter(p => p.value == this.dataObj.appData.groupCodeId)[0];
        this.maintenanceToElementType = this.dataObj.appData.maintenanceToElementType;
        this.maintenances = this.dataObj.appData.maintenances;
        if (this.maintenances && this.maintenances.length > 0)
          this.maintenance = this.maintenances.filter(p => p.value == this.dataObj.appData.maintenanceId)[0];
        this.serviceTypes = this.dataObj.appData.serviceTypes;
        if (this.serviceTypes && this.serviceTypes.length > 0)
          this.serviceType = this.serviceTypes.filter(p => p.value == this.dataObj.appData.serviceTypeId)[0];
        this.streetMaintenances = this.dataObj.appData.streetMaintenances;

        if (this.dataObj.appData.maintenanceId > 0 && this.dataObj.appData.maintenanceToElementType) {
          this.elementData.elementTypeId = this.dataObj.appData.maintenanceToElementType[this.dataObj.appData.maintenanceId];
          this.elementData.elementId = this.dataObj.appData.elementId;
          this.$root.$emit('element_data_updated');
        }

        if (this.dataObj.appData.employeeServiceTypeId && this.dataObj.appData.employeeServiceTypeId > 0)
          this.serviceType = this.serviceTypes.filter(p => p.value == this.dataObj.appData.employeeServiceTypeId)[0];

      });
    },
    setSelectedSTypes(code) {
      console.log(code);
    },
    setSelectedElement(code) {
      console.log(code);
    },
    setSelectedCostCenter(code) {
      console.log(code);
    },
    setSelectedGroupCode(code) {
      console.log(code);
    },
  },
  
}

